import { buildCorrelationData } from 'nmr-correlation';
import { formatData } from './formatData';
import { getIntegrationOfAttachedProtons } from './getIntegrationOfAttachedProtons';
export function getTargetsAndCorrelations(spectra, options = {}) {
    //add indirect links, if a carbon C1 is attached to a proton H1 that correlating
    //with carbon C2, so the carbon C1 and C2 are also correlating
    const { tolerance = { C: 0.25, H: 0.05 } } = options;
    const spectraData = formatData(spectra);
    const { values: correlations } = buildCorrelationData(spectraData, {
        tolerance,
    });
    const targets = {};
    for (const correlation of correlations) {
        if (correlation.pseudo)
            continue;
        const { id: targetID, atomType } = correlation;
        if (!targets[atomType])
            targets[atomType] = {};
        targets[atomType][targetID] = correlation;
        if (atomType === 'H') {
            targets[atomType][targetID].integration =
                correlation.link[0].signal.integration;
        }
        else {
            targets[atomType][targetID].integration = getIntegrationOfAttachedProtons(correlation, correlations);
        }
    }
    return {
        targets,
        correlations,
    };
}
//# sourceMappingURL=getTargetsAndCorrelations.js.map